import { useAddToast } from '@/components/base/toast/use-toast';
import { isAxiosError } from 'axios';
import { useTranslations } from 'next-intl';

export const useHandleMutationError = () => {
  const addToast = useAddToast();
  const t = useTranslations('common.error');

  return (error: Error) => {
    if (isAxiosError(error)) {
      if (error.response?.status === 500) {
        addToast({ type: 'error', content: t('toast.error_500') });
      } else if (
        error.response?.status === 400 &&
        error.response?.data?.error
      ) {
        const errorString = error.response.data.error;
        const fixedError = errorString.includes('|')
          ? errorString.split('|')?.[1]
          : errorString;
        addToast({
          type: 'error',
          content: t(fixedError),
        });
      } else {
        return error.response?.data?.message;
      }
    }
  };
};

export const useHandleToastError = () => {
  const t = useTranslations('common.error');
  const addToast = useAddToast();

  return (error: Error, errorMessage?: string) => {
    if (isAxiosError(error)) {
      addToast({
        type: 'error',
        content: t(errorMessage ?? error.response?.data?.error),
      });
    }
  };
};
